/**
 * Email Campaigns Page
 * Standalone page for email campaign management
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import EmailCampaignsTab from './EmailCampaignsTab';

const EmailCampaignsPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Email Campaign
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Create and manage email campaigns for customer communications
        </Typography>
      </Box>
      <EmailCampaignsTab />
    </Container>
  );
};

export default EmailCampaignsPage;
